var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6339 0.871179C23.5677 0.332091 24.7181 0.332092 25.6518 0.87118L43.5423 11.2002C44.476 11.7393 45.0512 12.7356 45.0512 13.8138V34.4719C45.0512 35.5501 44.476 36.5464 43.5423 37.0855L25.6518 47.4145C24.7181 47.9536 23.5677 47.9536 22.6339 47.4145L4.74346 37.0855C3.80973 36.5464 3.23453 35.5501 3.23453 34.4719V13.8138C3.23453 12.7356 3.80973 11.7393 4.74346 11.2002L22.6339 0.871179Z",
    fill: "url(#paint0_linear_8467_89193)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31V30C17 27.7909 18.7909 26 21 26H25C27.2091 26 29 27.7909 29 30V31",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23C21.3432 23 20 21.6569 20 20C20 18.3432 21.3432 17 23 17C24.6569 17 26 18.3432 26 20C26 21.6569 24.6569 23 23 23Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16H35",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 13V19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8467_89193",
    x1: 24.1429,
    y1: 0,
    x2: 24.1429,
    y2: 48.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8062F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3A91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep2);
export default __webpack_public_path__ + "static/media/SignupStep2.0858305cdbcd0b1af6c8d023c2ebc4e5.svg";
export { ForwardRef as ReactComponent };